import SectionManager from './SectionManager';
import CarouselManager from './CarouselManager';
import JsonManager from './JsonManager';

class SearchManager extends SectionManager {
  constructor() {
    super();
    this.allProjects = CarouselManager.getAllProjects();
    this.searchText = JsonManager.getSearch();
  }

  getPlaceHolder() {
    return this.searchText;
  }

  setProjectID(projectID) {
    this.projectID = projectID.article;
  }

  setupProjectsForSlide(value) {
    this.projects = this.getSuggestions(value);
    return this.getProjects();
  }

  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.allProjects.filter(
        project => project.article.toLowerCase().slice(0, inputLength) === inputValue
            || project.title.toLowerCase().slice(0, inputLength) === inputValue
            || project.subtitle.toLowerCase().slice(0, inputLength) === inputValue
            || this.constructor.checkSearchTerms(
              project.search.toLowerCase(),
              inputLength,
              inputValue,
            ),
      );
  }

  static checkSearchTerms(search, inputLength, inputValue) {
    this.i = 0;
    const terms = search.split(' ');
    const count = terms.length;
    for (let i = 0; i < count; i += 1) {
      const term = terms[i];
      if (term.slice(0, inputLength) === inputValue) {
        return true;
      }
    }
    return false;
  }
}

export default SearchManager;



// WEBPACK FOOTER //
// ./src/managers/SearchManager.js